// @flow
import { GroupsContactsActionTypes } from './constants';

type GroupsContactsAction = { type: string, payload: {} | string };

// common success
export const groupsContactsApiResponseSuccess = (actionType: string, data: any): GroupsContactsAction => ({
    type: GroupsContactsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const groupsContactsApiResponseError = (actionType: string, error: string): GroupsContactsAction => ({
    type: GroupsContactsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getGroupContact = (id: string): GroupsContactsAction => ({
    type: GroupsContactsActionTypes.GET_GROUPS_CONTACTS,
    payload: { id },
});

export const addGroupsContact = (groupoContacto:any):GroupsContactsAction=>({
    type:GroupsContactsActionTypes.ADD_GROUPS_CONTACTS,
    payload:groupoContacto
})
export const updateGroupsContact = (groupoContacto:any):GroupsContactsAction=>({
    type:GroupsContactsActionTypes.UPDATE_GROUPS_CONTACTS,
    payload:groupoContacto
})
export const deleteGroupsContact = (id:string):GroupsContactsAction=>({
    type:GroupsContactsActionTypes.DELETE_GROUPS_CONTACTS,
    payload:{id}
})

export const listGroupsContacts = (params:any): GroupsContactsAction => ({
    type: GroupsContactsActionTypes.LIST_GROUPS_CONTACTS,
    payload: params,
});


export const resetGroupsContacts = (): GroupsContactsAction => ({
    type: GroupsContactsActionTypes.RESET,
    payload: {},
});

